<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
  >
    <v-card 
      class="text-center py-3" 
    > 
      <v-row no-gutters>
        <v-col
          v-if="item.image_url" 
          cols="12"
          align="center"
        >
          <v-img
            contain 
            max-height="300"
            max-width="300"
            :src="item.image_url"
          />
        </v-col>
        <v-col
          cols="12"
          align="center"
        >
          <h2> {{ $t('you-received') }} {{ item.name }} </h2>
        </v-col>
        <v-col
          cols="12" 
          align="center"
        >
          <v-btn 
            depressed
            dark
            color="var(--bg-secondary-color)"
            @click="close()"
          >
            {{ $t('button.ok') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    item: {},
    angle : 0,
    mp : 100, //max particles
    particles : [],
    timeCelebrate:0,
    W : 0,
    H : 0,
    setTimeInterval : null,
    ctx:null
  }),  
  methods: {
    open (item) { 
      this.item = item
      this.timeCelebrate = 0
      this.dialog = true 
      this.W = window.innerWidth
      this.H = window.innerHeight

      for (var i = 0; i < this.mp; i++) {
        this.particles.push({
          x: Math.random() * this.W, //x-coordinate
          y: Math.random() * this.H, //y-coordinate
          r: Math.random() * 18 + 1, //radius
          d: Math.random() * this.mp, //density
          color: "rgba(" + Math.floor((Math.random() * 255)) + ", " + Math.floor((Math.random() * 255)) + ", " + Math.floor((Math.random() * 255)) + ", 0.8)",
          tilt: Math.floor(Math.random() * 5) - 5
        });
      }
      this.$nextTick(()=>{ 
        this.setTimeInterval = setInterval(()=>this.draw(), 20);
      })
    },
    close () { 
      this.dialog = false;
    },
    draw () {    
      if(this.timeCelebrate > 100) {  
        // this.ctx.clearRect(0, 0, this.W, this.H)
        clearInterval(this.setTimeInterval)
        return
      }

      // var canvas = document.getElementById("canvasCelebrate");
      // this.ctx = canvas.getContext("2d");
      // canvas.width = this.W;
      // canvas.height = this.H;
      // this.ctx.clearRect(0, 0, this.W, this.H);
      // for (var i = 0; i < this.mp; i++) {
      //   var p = this.particles[i];
      //   this.ctx.beginPath();
      //   this.ctx.lineWidth = p.r;
      //   this.ctx.strokeStyle = p.color; // Green path
      //   this.ctx.moveTo(p.x, p.y);
      //   this.ctx.lineTo(p.x + p.tilt + p.r / 2, p.y + p.tilt);
      //   this.ctx.stroke(); // Draw it
      // }
      
      this.update();
    },
    update () {
      this.angle += 0.01;
      this.timeCelebrate += 1;
      for (var i = 0; i < this.mp; i++) {
        var p = this.particles[i];
        p.y += Math.cos(this.angle + p.d) + 1 + p.r / 2;
        p.x += Math.sin(this.angle) * 2;
        if (p.x > this.W + 5 || p.x < -5 || p.y > this.H) {
          if (i % 3 > 0) //66.67% of the flakes
          {
            this.particles[i] = {
              x: Math.random() * this.W,
              y: -10,
              r: p.r,
              d: p.d,
              color: p.color,
              tilt: p.tilt
            };
          }
        }
      }
    }
  },
};
</script>